import { message } from 'antd'

export const getAppErrorMessage = (error) => {
  const data = error?.response?.data
  const validationErrors = Array.isArray(data?.errors) ? data.errors.filter(Boolean).join(', ') : data?.errors

  return validationErrors || data?.message || data?.msg || data?.error || error?.message || 'Something went wrong'
}

const handleAppError = (error, ...rest) => {
  if(error?.response?.status === 403) return

  message.error(getAppErrorMessage(error))
}

export default handleAppError
